import {Component, Input, OnInit} from '@angular/core';
import {NzModalRef} from 'ng-zorro-antd';
import {ProductsService} from '../../../services';
interface IBagdes {
  created: string;
  description: string;
  id: number;
  image: string;
  lastUpdated: string;
  name: string;
  statistic: string;
  status: number;
}
@Component({
  selector: 'app-modal-product-badge',
  templateUrl: './modal-product-badge.component.html',
  styleUrls: ['./modal-product-badge.component.scss']
})

export class ModalProductBadgeComponent implements OnInit {

  @Input() urlImageProduct;
  @Input() productName;
  @Input() barcodeProduct;
  @Input() badges;

  listOfData: IBagdes[] = [];

  constructor(public modalRef: NzModalRef<ModalProductBadgeComponent>,
              private productsService: ProductsService) { }

  ngOnInit() {
    this.productsService.getBagdes({
      page: 1,
      page_size: 50
    }).subscribe(res => {
      if (res && res.code === 1) {
        this.listOfData = res && res.data ? res.data : [];
      }
    });
  }

  openContact() {
    window.open(`https://icheck.com.vn/lien-he`, '_blank');
  }

}
